import axios from "@/plugins/axios";

let url = "/api/v1/dshop/orders";

export const orders = {
    // gets(data){
    //     return axios.get(url, data).then(result => result.data);
    // },
    // get(data){
    //     return axios.get(`${url}/${data._id}`).then(result => result.data);
    // },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    pay(data){
        return axios.post(`${url}/${data._id}/pay`).then(result => result.data);
    }
}
